/* =============================================================================
 * [OS-LEGADO-CONGELADO] ARQUIVO TEMPORARIO - APAGAR APOS VALIDACAO
 * =============================================================================
 * Copia CONGELADA do modulo antigo de "OS para coleta" (versao que estava em
 * producao antes da entrada do modulo novo).
 *
 * Origem desta copia: src/Components/ordemLaboratorio/styled.ts
 * Papel: componente compartilhado congelado
 *
 * POR QUE ISSO EXISTE
 *   O modulo novo de OS substituiu o antigo. Esta copia fica disponivel por
 *   ~1 SEMANA como plano de contingencia: se o modulo novo apresentar
 *   problema, o time volta a usar esta versao sem interromper o trabalho.
 *
 * NAO EDITE ESTE ARQUIVO
 *   Ele e um retrato fiel do comportamento antigo. Qualquer correcao deve ser
 *   feita no modulo NOVO. Editar aqui destroi o valor da copia.
 *
 * COMO APAGAR (quando o modulo novo for validado)
 *   1. Remover a pasta inteira: src/Views/app/precisao/OSAntigaLegado/
 *   2. Remover a rota/menu marcado com [OS-LEGADO-CONGELADO] em
 *      src/Configs/Navegacao.ts
 *   3. Conferir que nao sobrou nenhuma referencia:
 *        grep -rn "OSAntigaLegado\|OS-LEGADO-CONGELADO" src/
 *   Nada fora desta pasta depende dela, entao a remocao e segura.
 * ========================================================================== */

import styled from 'styled-components'

export const Container = styled.div`
position: relative;

  .ant-card-body {
    padding-bottom: 0;
  }

  .btn-ponto > .ant-card-body {
    padding: 0;
  }

  .class-remove {
    height: 60px !important;
  }
  .ant-card-actions {
    background-color: #d9d9d9;
    li {
      color: #000000;
    }
  }
  .ant-tabs-content {
    margin-left: 0 !important;
  }

  div.overlay_loading_lab {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

export const CardBtn = styled.div`
  .btn-ponto > .ant-card-body {
    padding: 5px;
    height: 30px;
    color: #fff;
    cursor: pointer;
  }
`
export const DivCultura = styled.div`
  border: 1px solid #d9d9d9;
  height: 30px;
  padding: 3px;
  border-radius: 5px;
  background-color: #f5f5f5;
  color: #c3c4c3;
  :hover{
    cursor: not-allowed;
  }
`

export const FooterModalLab = styled.div`
  width: 100%;
  height: 50px;
  border-top: thin solid var(--border-color);
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 15px;
`;
